import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { of, Observable, BehaviorSubject, combineLatest, throwError, forkJoin } from 'rxjs';
import { DocumentsRequest } from '../_models/document';
import { HttpClient } from '@angular/common/http';
import { map, switchMap, catchError, delay, retry } from 'rxjs/operators';
import { User } from '../_models/user';
import moment from 'moment';
import { AppService } from './app.service';
import { mtcTypes } from './_mocks/mockUserlist';
import * as _ from 'lodash';
import { mockDriverDocument } from './_mocks/mockDriverSigner'
import { take } from 'rxjs/operators'
import { Params } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class DocumentsService {

  private documents: BehaviorSubject<any[]>;
  public documents$: Observable<any[]>;
  
  constructor(
    private http: HttpClient,
    private appService: AppService
      ) {
    if (JSON.parse(localStorage.getItem('documents')) !== undefined && JSON.parse(localStorage.getItem('documents')) !== null) {
      this.documents = new BehaviorSubject<any[]>(JSON.parse(localStorage.getItem('documents')));
    } else {
      this.documents = new BehaviorSubject<any[]>([]);
    }
    this.documents$ = this.documents.asObservable();
  }

  public getDocuments(requestData: DocumentsRequest) {
    let currentUser: User = JSON.parse(localStorage.getItem("user"));
    const currentLocation = this.resolveCurrentLocation(currentUser);

    return this.http.post<any>(`${environment.apiUrl}/api/documentdetail`, { ...requestData, locationId: currentLocation.LocationId.toString() }).pipe(
      map(documents => {
        var sortAttributes = [{value: 'OD',asc: true}, {value: 'DocumentType', asc: false}];
        // this.sortDocs(sortAttributes);
        this.loadDocuments(documents);
        return documents;
      })
    );
  }

  private resolveCurrentLocation(currentUser: User) {
    if (!currentUser?.locationRoles?.length) {
      return { LocationId: 0 } as any;
    }

    return currentUser.locationRoles[currentUser.selectedLocationIndex]
      || currentUser.locationRoles.find(location => location.Selected)
      || currentUser.locationRoles[0];
  }
  public getDocumentsValue() {
    return this.documents.value;
  }

  public deleteDocuments(docsIds: Array<number>) {
    var controllerUriName = '';
    this.getCheckedDocuments().subscribe(data => {
      if (data.filter(d => d['Signed']).length > 0 )
        controllerUriName ='signdelete';
      else
        controllerUriName ='unsigndelete';
      });
    return this.http.post<any>(`${environment.apiUrl}/api/documentdetail/`+controllerUriName, { documents: docsIds })
  }

  public rejectDocs(docsIds: Array<number>) {
    return this.http.post<any>(`${environment.apiUrl}/api/documentdetail/reject`, { documents: docsIds })
  }

  public sortDocs(params: {value: string, asc: boolean}[]): void{
    this.documents.pipe(take(1)).subscribe((docs: any[]) => {
      const sortedDocuments = [...docs];

      sortedDocuments.sort((a,b) => {
        for (let i=0; i<params.length; i++){
          const param = params[i];
          const asc = param.asc ? 1 : -1;
          if(a[param.value] < b[param.value]) return 1 * asc;
          if(a[param.value] > b[param.value]) return -1 * asc;
        }
        return 0;
      });

      this.documents.next(sortedDocuments);
    })
  }

  public getCheckedDocIds() {
    /// por nominado
    return this.documents.value.filter(d => d.checked && !d.Nominated || d.checked && d.Nominated && d.Status.toLowerCase() === 'signed').map(d => d.Id);
  }

  public getDriverDocIds() {
    /// No se debe verificar checked ya que el documento no fue seleccionado desde ninguna vista previa.
    return this.documents.value.filter(d => !d.Nominated || d.Nominated && d.Status.toLowerCase() === 'signed').map(d => d.Id);
  }

  markDocumentsSigned(docs, currentUsr, pdfs, isDriverView : boolean = false) {
    docs.forEach((docId, i) => { 
      let doc = this.documents.value.find(d => d.Id === docId);
      if (doc) {
        /// por nominado
        if (!doc.Nominated) {
          doc.Signed = true;
        }
        else {
            doc['Signers'] = doc['Signers'].map(s => s['Status'].toLowerCase() !== 'signed' && this.compareUsr(s, currentUsr) ? { ...s, Status: 'Signed', LastModification: new Date() } : s);
            if (doc['Signers'].filter(s => s['Status'].toLowerCase() === 'signed').length === doc['Signers'].length) {
            doc.Status = 'Signed';
            doc.signed = true;
          }
          else {
            doc.Status = 'PartiallySigned';
          }

          let pdf = pdfs.find(d => d.docId === docId);
          pdf['Signers'] = doc['Signers'];
          pdf.Status = doc.Status;
          pdf.signed = doc.signed;
        }
      };
    });
    localStorage.setItem('documents', JSON.stringify(this.documents.value));
    this.documents.next(this.documents.value);
    return isDriverView ? this.getDriverCheckedDocuments() : this.getCheckedDocuments();
  }

  compareUsr(userSigner, currentUsr) {
    if(currentUsr){
      const prop = currentUsr.provider === 'AD' ? userSigner.Email : userSigner.UserFullName;
      return prop.toUpperCase().includes(currentUsr.email.toUpperCase());
    }
  }

  private loadDocuments(documents) {
    let parsedDocuments = [...documents];
    let i = 0;

    parsedDocuments.forEach(doc => {
      doc.checked = false;
      doc.Select = '';
      doc.id = i;
      doc.SignType.Size = doc?.Signers?.length > 1 && doc?.isDatabook ? 5.5 : 8.5;

      if (!!doc.AdditionalData?.length) {
        doc = Object.assign(doc, ...doc.AdditionalData.map(p => ({ [`AdditionalData.${p.PublicName}`]: p.Value })));
      }

      i++;
      // Replace all null values with empty string
      this.replaceNullValues(doc);
    });
    this.initDocuments(parsedDocuments);
  }

  public initDocuments(documents) {
    localStorage.setItem('documents', JSON.stringify(documents));
    this.documents.next(documents);
  }

  public checkForDocuments() {
    return this.documents.value.length > 0;
  }

  private replaceNullValues(document) {
    for (var key of Object.keys(document)) {
      if (document[key] === null || document[key] === undefined) {
        document[key] = '';
      }
    }
  }

  public getCheckedDocuments() {
      if (this.documents.value.length > 0) {
        return of(this.documents.value.filter(d => d.checked))
      }
    return of([]);
  }

  getDriverCheckedDocuments() {
      if (this.documents.value.length > 0) {
        return of(this.documents.value)
      }
    return of([]);
  }

  public getDriverDocuments(){
    this.loadDocuments(this.documents.value);
    return of(this.documents.value);
  }

  getDocumentsPdf(view: boolean = false) {

    const url = view ? 'view' : 'download';
    return this.getCheckedDocuments().pipe(
     switchMap(data => combineLatest(...data.map(input => this.http.get(`${environment.apiUrl}/api/documentdetail/${url}/${input.Id}`, {
        responseType: 'arraybuffer'
      }).pipe(retry(2))
        .toPromise()
        .then(async data => {
          const pdfBytes = new Uint8Array(data);
          const pdfHeader = String.fromCharCode(...pdfBytes.slice(0, 5));
          if (pdfHeader !== '%PDF-') {
            console.error('Document endpoint returned a non-PDF response', {
              documentId: input.Id,
              url: `${environment.apiUrl}/api/documentdetail/${url}/${input.Id}`,
              byteLength: pdfBytes.length,
              header: pdfHeader,
              preview: new TextDecoder().decode(pdfBytes.slice(0, 200))
            });
            throw new Error(`Invalid PDF response for document ${input.Id}`);
          }

          const obj = {
            downloadName: this.getName(input),
            docId: input.Id,
            SignType: input.SignType,
            pdf: data,
            signed: input.Signed,
            Status: input.Nominated ? input.Status : +input.Signed,
            Signers: input.Signers
          }
          return obj
        })       
      ))),
      catchError(e => {
        return throwError(e);
      }));
  }

  getSicramDocumentsPdf(view: boolean = false, merged: boolean = false, encryptedGuid?: string) {
    const url = view ? 'view' : 'download';

    if(url == 'download' && merged){
      return this.getDriverDocuments()
      .pipe(
        switchMap(data => {
          const firstElement = data[0];
          return combineLatest(this.http.get(`${environment.apiUrl}/api/driversign/mergeddocs/${encryptedGuid}`, {responseType: 'arraybuffer'})
            .pipe(retry(2))
            .toPromise()
            .then(async data => {
              const obj = {
                downloadName: this.getName(firstElement),
                docId: firstElement.Id,
                SignType: firstElement.SignType,
                pdf: data,
                signed: firstElement.Signed,
                Status: firstElement.Nominated ? firstElement.Status : +firstElement.Signed,
                Signers: firstElement.Signers
              }
              return obj
            })
          )
        }),
        catchError(e => {
          return throwError(e);
      }));
    }
    else{
      return this.getDriverDocuments().pipe(
      switchMap(data => combineLatest(...data.map(input => {
        return this.http.get(`${environment.apiUrl}/api/driversign/${url}/${input.DocumentKey}`, {
          responseType: 'arraybuffer'
        }).pipe(retry(2))
          .toPromise()
          .then(async data => {
            const obj = {
              downloadName: this.getName(input),
              docId: input.Id,
              SignType: input.SignType,
              pdf: data,
              signed: input.Signed,
              Status: input.Nominated ? input.Status : +input.Signed,
              Signers: input.Signers
            }
            return obj
          });
        }))),
        catchError(e => {
          return throwError(e);
        }));
    }
  }

  sendSignedDocuments(docs, isDriverView = false) {    
    let successDocIds = [];
    let errDocIds = [];
    return of(docs).pipe(switchMap(data => {
      const obs$ = data.map(input => {
        let locationIdDoc = input.SignType.LocationId;
        let currentUser: User = JSON.parse(localStorage.getItem("user"));
        const currentLocation = currentUser?.locationRoles[currentUser.selectedLocationIndex];
        let formData = new FormData();
        formData.append('DocumentId', input.docId);
        formData.append('Date', moment().format());
        if(!input.SignType.BackendSign)
          formData.append('SignedFile', new Blob([input.pdf], { type: "application/pdf" }), `${input.downloadName}.pdf`);
        formData.append('LocationId', locationIdDoc/* currentLocation?.LocationId.toString() */);
        var controllerName = "documentdetail";
        if(isDriverView){
          controllerName = "driversign";
        }
        return this.http.post(`${environment.apiUrl}/api/${controllerName}/sign`, formData)
        //return of(true)
        .pipe(
          retry(2),
          map(data => {
          successDocIds.push(input.docId);
          input.signed = true;
        }),
          //retry(2),
          catchError(err => {
            errDocIds.push(input.docId);
            return of(err);
          })
        );
      })
      return forkJoin(obs$);
    }), map(data => {
      if (successDocIds.length === 0 && errDocIds.length > 0) {
        throw new Error('sign.pdf_get_error');
      }
      else {
        return { success: successDocIds, err: errDocIds };
      }
    })
    )
  }

  private getName(input) {
    /// por nominado
    if (input.Nominated) return input.DocumentName;

    let odItems = input.ODItems && input.ODItems.length ? input.ODItems.map(i => { return `-${i.Number}` }) : '';
    odItems = odItems.join('').replace('-', '');
    return input.Signed ? `${input.OD}-${odItems}-${input.DocumentType}-signed.pdf` :
      `${input.OD}-${odItems}-${input.DocumentType}-not-signed.pdf`;
  }

  emailSend(emails, driverview: boolean = false) {
    
    const docIds = driverview ? this.getDriverDocIds() : this.getCheckedDocIds();

    if (!!!docIds.length) return of(false);
    const body = {
      From: null,
      To: emails.map(e => e.value.toLowerCase()),
      Documents: docIds
    };
    
    if(driverview){

      return this.http.post(`${environment.apiUrl}/api/driversign/send`, body);
    }
    else{
      return this.http.post(`${environment.apiUrl}/api/mail/send`, body);
    }
  }

  clearStorage() {
    localStorage.removeItem('documents');
    this.documents.next(null);
  }
}
